var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrchestrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8719 3.90089C13.8719 3.29267 14.3649 2.79961 14.9732 2.79961H20.1014C20.7096 2.79961 21.2026 3.29267 21.2026 3.90089V9.0291C21.2026 9.63732 20.7096 10.1304 20.1014 10.1304H14.9732C14.3649 10.1304 13.8719 9.63732 13.8719 9.0291V3.90089Z",
    stroke: "#696869",
    strokeWidth: 1.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8719 14.9771C13.8719 14.3688 14.3649 13.8758 14.9732 13.8758H20.1014C20.7096 13.8758 21.2026 14.3688 21.2026 14.9771V20.1053C21.2026 20.7135 20.7096 21.2065 20.1014 21.2065H14.9732C14.3649 21.2065 13.8719 20.7135 13.8719 20.1053V14.9771Z",
    stroke: "#696869",
    strokeWidth: 1.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7957 14.9771C2.7957 14.3688 3.28876 13.8758 3.89699 13.8758H9.02519C9.63341 13.8758 10.1265 14.3688 10.1265 14.9771V20.1053C10.1265 20.7135 9.63341 21.2065 9.02519 21.2065H3.89698C3.28876 21.2065 2.7957 20.7135 2.7957 20.1053V14.9771Z",
    stroke: "#696869",
    strokeWidth: 1.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99862 9.26748L9.26219 6.00391L5.99862 2.74034L2.73505 6.00391L5.99862 9.26748ZM10.5676 7.30933C11.2886 6.58837 11.2886 5.41945 10.5676 4.69848L7.30405 1.43491C6.58308 0.71394 5.41416 0.71394 4.69319 1.43491L1.42962 4.69848C0.708655 5.41945 0.708655 6.58837 1.42962 7.30933L4.69319 10.5729C5.41416 11.2939 6.58308 11.2939 7.30405 10.5729L10.5676 7.30933Z",
    fill: "#696869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrchestrate);
export default __webpack_public_path__ + "static/media/orchestrate.1fe7946dad75dbb61fa0165708d0d079.svg";
export { ForwardRef as ReactComponent };